import { Property } from '@innovyze/stylovyze';
import { isYearField } from '@Utils/yearField.utils';

/**
 * Maps a schema field type onto the `PropertyCard` display type.
 *
 * `propertyId` is needed because the schema types year-only fields as dates -
 * see the year handling below.
 */
export const getType = (
	type?: string,
	unit?: string,
	propertyId?: string,
): Property['type'] => {
	// Year fields are typed as dates in the schema but only hold a year, so they
	// must render as text - PropertyCard would otherwise try to re-parse the
	// already normalised value as a date. (I360A-2587)
	if (isYearField(propertyId)) return 'text';
	if (unit === '$') return 'currency';
	if (unit) return 'unit';
	if (type) {
		if (type === 'string') return 'text';
		if (type === 'date') return 'dateonlyUTC';
		if (type === 'datetime' || type === 'time') return 'dateUTC';
		return type as Property['type'];
	}
	return 'text';
};
